import React from "react";
import theme from "storybook-styles/theme";

const LastPageIcon = ({ disabled }) => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8L4 4V8L8 4L4 0V4L0 0V8Z"
      fill={disabled ? theme.colors.gray6 : theme.colors.green5}
    />
  </svg>
);

export default LastPageIcon;
